
import { useCommonDataProvider, Options } from 'app/dataProviders/useCommonDataProvider'
import { GET_CATEGORIES_LIST, convertParams, convertResult } from 'app/common/api/requests/food/schools/item_categories/get'
import { CategoryList, Params } from 'app/dataTypes/categories'


const defaultState: Array<CategoryList> = []

type Op = Omit<Options<
  Array<CategoryList>,
  Params
>, 'requestValue' | 'convertions' | 'defaultState'>

export function useCategoriesList(options: Op = {} as Op) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_CATEGORIES_LIST,
    error: 'Не удалось получить список категорий',
    convertions: {
      convertParams,
      convertResult
    },
    defaultState,
  })

  return res
}
